import { render, staticRenderFns } from "./SearchAddress.vue?vue&type=template&id=38fd5fde&scoped=true&"
import script from "./SearchAddress.vue?vue&type=script&lang=js&"
export * from "./SearchAddress.vue?vue&type=script&lang=js&"
import style0 from "./SearchAddress.vue?vue&type=style&index=0&id=38fd5fde&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fd5fde",
  null
  
)

export default component.exports